import { Intro } from './Intro.js'

export default Intro;



// WEBPACK FOOTER //
// ./src/components/Intro/index.js